import {
  Box,
  Button,
  Grid,
  Link,
  SpaceBetween,
  FormField,
  Input,
  StatusIndicator,
  Checkbox,
  Form,
  Popover,
  Autosuggest,
  Alert,
  RadioGroup,
  ContentLayout,
  Container,
  Tabs,
  Table,
  TextFilter,
  Select,
  Header,
  Pagination,
  CollectionPreferences,
  Modal,
} from "@cloudscape-design/components";
import { useEffect, useState, useContext } from "react";
import { GlobalContext, ContentContext } from "../../../context";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { withAuthenticator, Authenticator } from '@aws-amplify/ui-react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { navigateFn } from "../../../routingHelper";
import useAxios, {
  configure,
  loadCache,
  serializeCache,
  makeUseAxios,
} from 'axios-hooks'
import { leagueId, apiKey, baseUrl } from '../../../leagueId';
import { RotatingLines, ThreeDots, BallTriangle } from  'react-loader-spinner'
import * as awsui from "@cloudscape-design/design-tokens";
import usePlacesService from "react-google-autocomplete/lib/usePlacesAutocompleteService";
import DatePicker from '../../../components/date-picker/DatePicker';
import { useLocalStorage } from 'usehooks-ts';
import { CustomButton } from "../../../components/buttons";
import { LeagueDriver } from "../../../../../infra/lib/data-classes/league-driver/league-driver.interface"
import DriverTable from "../../../components/driver-table/driver-table";

const axiosHeaders = { 
  "api-key": apiKey, 
  "Content-Type": "application/json",
}



function LeagueAdmin() {
  const navigate = navigateFn({
    navigate: useNavigate(),
    location: useLocation(),
  })
  const location = useLocation();
  const { 
    userAttributes, setUserAttributes,
  } = useContext(GlobalContext);
  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const { route } = useAuthenticator(context => [context.route]); 
  const { authStatus } = useAuthenticator(context => [context.authStatus]); 

  const [ modalVisible, setModalVisible ] = useState(false);
  const [ modalContent, setModalContent ] = useState();

  const [ seriesId, setSeriesId ] = useState<string>("01H51VP9QX6TDT5W097GACKS33")
  

  if (!userAttributes.groups.includes('LeagueAdmin')) {
    navigate('/')
  }

  const [{ data: leagueDrivers = [], loading: leagueDriversLoading, error: leagueDriversError}, getLeagueDriver] = useAxios({
    url: baseUrl + "/league-driver",
    method: "get",
    headers: axiosHeaders,
    params: {
      method: "list",
      leagueId: leagueId,
      driverId: userAttributes["custom:leagueDriverId"],
    },
  }, {
    manual: false,
  });

  const [{ data: seriesDrivers = [], loading: seriesDriversLoading, error: seriesDriversError}, getSeriesDriver] = useAxios({
    url: baseUrl + "/series-driver",
    method: "get",
    headers: axiosHeaders,
    params: {
      method: "list",
      leagueId: leagueId,
      seriesId: seriesId,
      driverId: userAttributes["custom:leagueDriverId"],
    },
  }, {
    manual: false,
  });


  const sortItems = (items:any) => {    // getLeagueDriver()
    if (items !== undefined){
      const sortedItems = items.sort((a:any, b:any) => {
        // if (a.name > b.name) return sortingDescending ? -1 : 1;
        if (a.name < b.name) return 1;
      })
      return sortedItems
    }
    return items
  }
   
  const leagueTableColumns = [ 'name', 'country', 'irUserId', 'irUserName', 'discordId', 'registrationDate' ]
  const seriesTableColumns = [ 'irUserName', 'irUserId', 'country', 'registrationDate' ]
  const trinationsTableColumns = [ 'irUserName', 'irUserId', 'address', 'country', 'registrationDate' ]


  return (
    <>   
      <center>
        <ContentLayout
          header={
            <div 
              className="account-header-container" 
              style={{ 
                height: "100px",
                maxHeight: "100px",
                width: "100%",
                zIndex: "3",
              }} 
            />
          }
        >
          <div className="body-content">
            <Container>
              <center>
                League Admin Navigation
              </center>
            </Container>
          </div>
        </ContentLayout>
      </center>
      <center>
        <div style={{width: "100%", paddingTop: "50px", paddingBottom: "50px"}}>
          <div className="body-content">   
            <Tabs
              onChange={({ detail }) => setSeriesId(detail.activeTabId)}
              activeTabId={seriesId}
              variant="default"
              key={"drivers-table"}
              tabs={[
                {
                  label: "League Drivers",
                  id: leagueId,
                  content: <>{ DriverTable(sortItems(leagueDrivers), leagueTableColumns, leagueDriversLoading) }</>,
                },
                {
                  label: "Tri Nations Series",
                  id: "01H51VP9QX6TDT5W097GACKS33",
                  content: <>{ DriverTable(sortItems(seriesDrivers), trinationsTableColumns, seriesDriversLoading) }</>,
                },
                {
                  label: "Junior Championship",
                  id: "01H51VP9QX234T5W097GACKS33",
                  content: <>{ DriverTable(sortItems(seriesDrivers), seriesTableColumns, seriesDriversLoading) }</>,
                  disabled: true
                }
              ]}
            />
          </div>
        </div>
      </center>
    </>
  );
}


export default withAuthenticator(LeagueAdmin);